'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var routes = [
// 会员类型选择
{
  path: '/vip/info',
  component: function component() {
    return import('@views/vip/info.vue');
  },
  name: 'vip-info',
  meta: {
    auth: ['authc'],
    group: 'vip',
    title: '加入会员'
  }
},
// 订单
{
  path: '/vip/order',
  component: function component() {
    return import('@views/vip/order.vue');
  },
  name: 'vip-order',
  meta: {
    auth: ['authc'],
    group: 'vip',
    title: '生成订单'
  }
},
// 确认订单
{
  path: '/vip/order/confirm/:from/:id',
  component: function component() {
    return import('@views/vip/order-confirm.vue');
  },
  name: 'vip-order-confirm',
  meta: {
    auth: ['authc'],
    group: 'vip',
    title: '确认订单'
  }
},
// 确认订单
{
  path: '/vip/order/confirm/:from/:orderId/:id',
  component: function component() {
    return import('@views/vip/order-confirm.vue');
  },
  name: 'vip-order-pay',
  meta: {
    auth: ['authc'],
    group: 'vip',
    title: '确认订单'
  }
},
// 订单详情
{
  path: '/vip/order/detail/:orderId/:id',
  component: function component() {
    return import('@views/vip/order-detail.vue');
  },
  name: 'vip-order-detail',
  meta: {
    auth: ['authc'],
    group: 'vip',
    title: '订单详情'
  }
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ./src/router/vip.js
// module id = 587
// module chunks = 14